var render, staticRenderFns
import script from "./BaseTree.vue?vue&type=script&lang=js&"
export * from "./BaseTree.vue?vue&type=script&lang=js&"
import style0 from "./BaseTree.vue?vue&type=style&index=0&id=50ae38e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae38e2",
  null
  
)

export default component.exports